/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function ColorBlindDeuteranopia(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'ColorBlindDeuteranopia',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 16 * scale,
      viewBox: '0 0 16 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fillRule":"evenodd","clipRule":"evenodd","d":"M5 13.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2M5 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8","fill":"#2FC862"}),createElement('path', {"d":"M9.346 14.371A5.48 5.48 0 0 0 10.5 11c0-1.27-.43-2.44-1.154-3.371a4 4 0 1 1 0 6.742","fill":"#2496FF"}),createElement('path', {"d":"M9.909 8.516a4 4 0 1 0-5.866-2.933 5.5 5.5 0 0 1 5.866 2.933","fill":"#FF424D"}))
}
